export default "/images/vendor/flag-icon-css/flags/1x1/sr.svg?4ee190817d3b7c7862ca83e56bea902d";